import { useCountryInfo } from 'legacy/lut/hooks/useCountryInfo'
import { memo } from 'react'

import { IContact } from 'clickNgo/entities/contact'
import { SimpleTable } from 'cng-common/components/simpleTable'

import styles from './ContactDetailsAdditional.module.scss'

interface Props {
  contact: IContact
}

export const ContactDetailsAdditional = memo<Props>(({ contact }) => {
  const countryOfBusiness = useCountryInfo(contact.countryOfBusiness)

  return (
    <div className={styles.contactDetailsWrapper}>
      <SimpleTable className={styles.contactDetailsTable}>
        <SimpleTable.HeaderRow className={styles.contactDetailsTableHeaderRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Location & user
          </SimpleTable.HeaderCell>
        </SimpleTable.HeaderRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Partner id
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.partnerId || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Communication Name
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.communicationName || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            City
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.city || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Country of business
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {countryOfBusiness?.value || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Preferred language
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.preferredLanguage || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            User status
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.userStatus || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Login Id
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.loginId || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            HP id
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.hpPassportProfileId || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            HPD contact GUID
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.hpdContactGUID || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
        <SimpleTable.BodyRow className={styles.contactDetailsTableBodyRow}>
          <SimpleTable.HeaderCell className={styles.contactDetailsTableHeaderCell}>
            Last login
          </SimpleTable.HeaderCell>
          <SimpleTable.BodyCell className={styles.contactDetailsTableBodyCell}>
            {contact.userLastLoginDate || '-'}
          </SimpleTable.BodyCell>
        </SimpleTable.BodyRow>
      </SimpleTable>
    </div>
  )
})
